export default "__VITE_ASSET__BlyXTd8T__"